import { ConsentSigningSection } from "@/features/consent/components/ConsentSigningSection";
import InterfaceButtons from "@/features/patients/features/interface/components/InterfaceButtons";
import { createFileRoute } from "@tanstack/react-router";

function PatientDiaryConsentPage() {
    const { consentId, diaryId } = Route.useParams();

    return (
        <section className="flex flex-col">
            <InterfaceButtons diaryId={diaryId} className="pb-3" />
            <ConsentSigningSection consentId={consentId} diaryId={diaryId} routeContext="patients" />
        </section>
    );
}

export const Route = createFileRoute("/_app/patients/$diaryId/consent/$consentId/")({
    component: PatientDiaryConsentPage,
});
